module.exports = __webpack_public_path__ + "029c2e0e19032f6cdbef9042552e79fa.woff2";